import Text from 'components/Text';
import styled from 'styled-components/native';

export const InvoiceNominativeMonth = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
`;
